import { MapEnv } from "@phoarau/ts_sysop_utils";

window["aster_centre"] = "reunion";
window["aster_api_server"] = "https://api.aster.run";
window["aster_map_name"] = "re";
// eslint-disable-next-line @typescript-eslint/no-require-imports
window["aster_map_geojson"] = require("../config/974.json");
window["aster_center_lat"] = -21.13;
window["aster_center_lng"] = 55.53;
window["aster_center_zoom"] = 10.5;
window["aster_has_ilere"] = false;
window["aster_ilere_url"] = "http://ile.6op.fr/";
window["aster_has_appel_urgence"] = true;
window["aster_filaire_path"] = "http://163.101.163.47/occ_hta/schemas/Schemas%20individuels/F_";
window["aster_country_code"] = "re";

MapEnv.values = {
    centerLat: -21.13,
    centerLng: 55.53,
    centerZoom: 10.5,
    googleMapsApiKey: "AIzaSyD1b0vX1dF5n1kJ9K3YkWQJt8mY5x0h8y8",
    mapId: "1a756cf9871a5d0"
}